// TODO: REFACTORING
import React from 'react';
import Style from './style.module.css';

const Chip = ({ svgSource, text }) => {
  return (
    <div className={Style.container}>
      <span
        className={Style.icon}
        dangerouslySetInnerHTML={{ __html: svgSource }}
      ></span>
      <p className={Style.text}>{text}</p>
    </div>
  );
};

export default Chip;
